import { Grid, Typography } from '@mui/material';
import { Box, BoxProps } from '@mui/system';
import { map } from 'lodash';
import { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import dataSource from 'src/data-sources/capabilities.json';
import { IconBox } from '../icon-box';

export const Capabilities: ComponentType<BoxProps> = (props) => {
  const { t } = useTranslation();

  return (
    <Box {...props}>
      <Typography variant="h1" component="h2" mb={5}>
        {t('systemCapabilities', 'Возможности системы')}
      </Typography>
      <Grid container spacing={4}>
        {map(dataSource, (item, index) => (
          <Grid item xs={12} md={6} key={index}>
            <IconBox item={item} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
